import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import { PageHeader } from '@verantos-dev/shared-components';

import { AvLibraryDetailModal } from './components/AvLibraryDetailModal';
import { AvLibraryGrid } from './components/AvLibraryGrid';
import { useAvLibraryPage } from './hooks/useAvLibraryPage';

export const AvLibraryPage = () => {
  const intl = useIntl();
  const { selectedAv, handleNameClick, handleCloseDetail } = useAvLibraryPage();

  return (
    <Box data-testid="av-library-list-page">
      <PageHeader
        id="av-library-page-header"
        data-testid="av-library-page-header"
        pageTitle={intl.formatMessage({ id: 'avLibrary.pageTitle' })}
      />
      <AvLibraryGrid onNameClick={handleNameClick} />
      {selectedAv && (
        <AvLibraryDetailModal analyticalVariable={selectedAv} onClose={handleCloseDetail} />
      )}
    </Box>
  );
};

export default AvLibraryPage;
